import { ConfigProvider } from 'antd';
import Routes from "./routes/ProjectRoutes"
import fa_IR from "antd/es/locale/fa_IR"; 
import "./App.scss"
function App() {
  return (
    <ConfigProvider direction='rtl' locale={fa_IR}>

    <Routes />
    </ConfigProvider>
  )
}
export default App;